import { render, staticRenderFns } from "./ArrobaMedellinHorizontalCardIdi.html?vue&type=template&id=0493331d&scoped=true&external"
import script from "./ArrobaMedellinHorizontalCardIdi.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinHorizontalCardIdi.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinHorizontalCardIdi.scss?vue&type=style&index=0&id=0493331d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0493331d",
  null
  
)

export default component.exports